__turbopack_context__.v({
  "bannerTitle": "ReferAFriendBanner-module__5BbRVW__bannerTitle",
  "beachBottomRight": "ReferAFriendBanner-module__5BbRVW__beachBottomRight",
  "container": "ReferAFriendBanner-module__5BbRVW__container",
  "crab": "ReferAFriendBanner-module__5BbRVW__crab",
  "innerContainer": "ReferAFriendBanner-module__5BbRVW__innerContainer",
  "offerText": "ReferAFriendBanner-module__5BbRVW__offerText",
  "outerContainer": "ReferAFriendBanner-module__5BbRVW__outerContainer",
  "referrerImage": "ReferAFriendBanner-module__5BbRVW__referrerImage",
  "textContainer": "ReferAFriendBanner-module__5BbRVW__textContainer",
});
